var API_DOMAIN  = "https://abinaya.zentexus.com/api";

export default API_DOMAIN